"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECRUITMENT_FIELD_MAX_LENGTH = void 0;
exports.RECRUITMENT_FIELD_MAX_LENGTH = {
    BENEFITS: 2000,
    DESCRIPTION: 5000,
    HIGHLIGHT: 200,
    TESTIMONIAL: 1000,
    TITLE: 200,
    WORK_HOURS: 200,
};
